<ng-container *ngFor="let line of lines; let index = index; let isFirst = first">
  <svg:g
    f-line
    [data]="line"
    [xScale]="xScale"
    [yScale]="lineDashArrays[index] && lineYScale ? lineYScale : yScale"
    [curved]="curved"
    [lineWidth]="lineWidth"
    [circleRadius]="circleRadius"
    [lineClasses]="lineClasses[index] || []"
    [strokeDashArray]="lineDashArrays[index]"
    [showPointerLine]="isFirst ? showPointerLine : false"
    [activeDataPointId]="activeDataPointId"
    [nearestXPointer]="nearestXPointer"
    [popoverTemplate]="isFirst ? popoverTemplate : null"
    [popoverPlacement]="popoverPlacement"
    [popoverOpenDelay]="popoverOpenDelay"
    [popoverData]="isFirst ? cachedPopoverData : null"
    [animationDuration]="animationDuration"
    [animationDelay]="animationDelay"
    [animation]="animation"
  />
</ng-container>
